<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{ name: 'RegisterDayOfTheWeek' }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <template v-if="hasDayOfTheWeek">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
              v-for="dayOfTheWeek in daysOfTheWeek"
              :key="dayOfTheWeek.id"
            >
              <CardDayOfTheWeek :dayOfTheWeek="dayOfTheWeek" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardDayOfTheWeek from "@/views/Professional/components/CardDayOfTheWeek";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Profissional",
          routerName: "Professional",
        },
        {
          name: "Listar dias da semana",
          routerName: "ListDaysOfTheWeek",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      daysOfTheWeek: "Professional/daysOfTheWeek",
    }),
    hasDayOfTheWeek() {
      return (
        this.daysOfTheWeek &&
        Array.isArray(this.daysOfTheWeek) &&
        this.daysOfTheWeek.length > 0
      );
    },
  },
  components: {
    Breadcrumb,
    CardDayOfTheWeek,
  },
  methods: {
    ...mapActions("Professional", ["consultDaysOfTheWeek"]),
  },
  mounted() {
    this.consultDaysOfTheWeek();
  },
};
</script>
